import type { ThreadPriority } from '#lib/plain/types'
import { supportClient } from './support-client'

export async function createSupportTicket({
  accountSlug,
  subject,
  description,
  priority,
}: {
  accountSlug: string
  subject: string
  description: string
  priority: ThreadPriority
}) {
  const response = await supportClient[':account'].threads.$post({
    param: {
      account: accountSlug,
    },
    json: {
      subject,
      description,
      priority,
    },
  })

  if (!response.ok) throw new Error('Failed to submit support ticket')

  return await response.json()
}
